<script setup lang="ts">
const props = defineProps<{
  resourceId: number
  resourceType: ResourceType
  vertical?: boolean
}>()
const $toast = useToast()
const { data: userInfo } = useAuth()
async function handleClick() {
  if (!userInfo.value.login) {
    useEmitter().emit('requestLogin')
    return
  }
  useEmitter().emit('openReportForm', {
    resourceId: props.resourceId,
    resourceType: props.resourceType
  })
}
</script>

<template>
  <m-icon
    class="pointer"
    icon="lucide-alert-triangle"
    :vertical="vertical"
    @click="handleClick"
  >
    <slot />
  </m-icon>
</template>
